export default __webpack_public_path__ + "static/media/img1-1.2cf3f745.jpg";